import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Grid, Card, CardContent, CardActionArea } from '@mui/material';

const cards = [
    { to: '/admin/teams', title: 'Drużyny', desc: 'Dodawaj, edytuj i usuwaj drużyny.' },
    { to: '/admin/seasons', title: 'Sezony', desc: 'Twórz sezony, przypisuj drużyny i kolejki.' },
    { to: '/admin/news', title: 'Aktualności', desc: 'Zarządzaj wpisami na stronie głównej.' },
];

const AdminDashboard = () => (
    <>
        <Typography variant="h4" gutterBottom>
            Pulpit
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
            Wybierz sekcję, którą chcesz zarządzać.
        </Typography>
        <Grid container spacing={2}>
            {cards.map((c) => (
                <Grid item xs={12} sm={6} md={4} key={c.to}>
                    <Card>
                        <CardActionArea component={RouterLink} to={c.to}>
                            <CardContent>
                                <Typography variant="h6">{c.title}</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {c.desc}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            ))}
        </Grid>
    </>
);

export default AdminDashboard;
